import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel, MenuItem, Select, Tooltip, Typography, type SelectChangeEvent } from '@mui/material';
import { type Provider, type Account, AccountState } from '@repo/api-gw-sdk';
import React from 'react';
import { useRoles } from '@/contexts/useRoles';
import { CloudProviders } from '@/data/inventory/data';
import { SelectPlaceholder } from '../selectPlaceholder';
import { EmptySelect } from '../selectors/emptySelect';
import { TextLink } from '../shared/textLink';
export type VaultManagedType = 'eon-managed' | `self-managed-${Provider}`;
export const VaultManagedTypeSelect = t0 => {
  const $ = _c(21);
  const {
    title,
    selfManagedVaultAccounts,
    showEonManaged,
    restrictedCloudProviders,
    vaultManagedType,
    onChange
  } = t0;
  const {
    isAuthorized
  } = useRoles();
  if (!selfManagedVaultAccounts.length) {
    let t1;
    if ($[0] !== title) {
      t1 = <EmptySelect title={title} size="medium" />;
      $[0] = title;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== onChange) {
    t1 = event => {
      onChange(event.target.value);
    };
    $[2] = onChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSelect = t1;
  let t2;
  if ($[4] !== title) {
    t2 = <FormLabel>{title}</FormLabel>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paddingLeft: "8px"
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = vaultManagedType || "";
  let t5;
  if ($[7] !== showEonManaged) {
    t5 = showEonManaged && <MenuItem key="eon-managed" value="eon-managed">Eon-managed (recommended)</MenuItem>;
    $[7] = showEonManaged;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isAuthorized || $[10] !== restrictedCloudProviders || $[11] !== selfManagedVaultAccounts) {
    t6 = Object.values(restrictedCloudProviders).map(cloudProvider => {
      const disabled = selfManagedVaultAccounts.filter(a => a.cloudProvider === cloudProvider && a.state !== AccountState.ACCOUNT_STATE_DISCONNECTED).length === 0;
      const menuItem = <MenuItem disabled={disabled} key={`self-managed-${cloudProvider}`} value={`self-managed-${cloudProvider}`}>{getLabel(`self-managed-${cloudProvider}`)}</MenuItem>;
      const path = `/global-management/vault-accounts/${cloudProvider.toLowerCase() === "azure" ? "azure-subscriptions" : cloudProvider.toLowerCase() === "gcp" ? "gcp-projects" : "aws-accounts"}`;
      return disabled ? <Tooltip disableInteractive={false} key={`self-managed-${cloudProvider}`} title={<Typography className="text-inherit">No vault accounts are connected. To create a vault, connect at least one vault account.{" "}<TextLink className="text-inherit hover:text-inherit" disabled={!isAuthorized("read:vault_accounts")} href={path}>Manage vault accounts.</TextLink></Typography>}><span>{menuItem}</span></Tooltip> : menuItem;
    });
    $[9] = isAuthorized;
    $[10] = restrictedCloudProviders;
    $[11] = selfManagedVaultAccounts;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onSelect || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <Select sx={t3} size="medium" value={t4} onChange={onSelect} displayEmpty={true} renderValue={_temp}>{t5}{t6}</Select>;
    $[13] = onSelect;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t7) {
    t8 = <FormControl size="small" className="flex-1">{t2}{t7}</FormControl>;
    $[18] = t2;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
const getLabel = (vaultType: VaultManagedType) => {
  if (vaultType === 'eon-managed') {
    return 'Eon-managed (recommended)';
  }
  return `Self-managed in ${CloudProviders[vaultType.split('self-managed-')[1] as Provider].displayName}`;
};
function _temp(value) {
  if (!value) {
    return <SelectPlaceholder />;
  }
  return getLabel(value as VaultManagedType);
}